import { vars } from '@etg/wings';
import { useTranslation, useProperty } from '@eti/providers';
import { css, mediaQueries, resetButtonStyle } from '@eti/styles';
import TripDetailsTitle from './TripDetailsTitle';
import { useResultPageContext } from './contexts/ResultPageContext';

const searchTextStyles = css`
  color: ${vars.colors.links.default};
  font-size: 0.875rem;
  text-decoration: underline;

  &:hover {
    color: ${vars.colors.links.focus};
  }
`;

const wrapperStyles = (isAlternateSearchBarEnabled: boolean) => css`
  align-items: flex-start;
  display: flex;
  gap: 4px;
  ${resetButtonStyle};
  ${isAlternateSearchBarEnabled
    ? `flex-direction: column-reverse; gap: 10px;`
    : `flex-direction: column; justify-content: space-between;`};
  padding: 8px 0;
  position: relative;
  width: 100%;

  &:hover {
    a {
      ${isAlternateSearchBarEnabled &&
      `border-color: ${vars.colors.button.secondary.hover.border};
         background-color: ${vars.colors.button.secondary.hover.base};
         color: ${vars.colors.button.secondary.hover.label};
        `};
    }
  }

  @media ${mediaQueries.medium.up} {
    flex-direction: row;
    ${isAlternateSearchBarEnabled ? `gap: 20px;` : `gap: 32px;`};
    padding: 16px 0;
  }
`;

const searchLabelStyles = css`
  align-items: center;
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
  display: flex;
  font: inherit;
  outline: inherit;
  padding: 0;

  &:focus-visible {
    color: ${vars.colors.links.focus};
    outline: 2px solid ${vars.colors.focusRing};
    outline-offset: 2px;
  }
`;

interface ResultTripDetailsHeaderProps {
  isOpen?: boolean;
  onClick: () => void;
}

const ResultTripDetailsHeader = ({ isOpen, onClick }: ResultTripDetailsHeaderProps) => {
  const { shouldShowSkeletonOnResultPage } = useResultPageContext();
  const { t } = useTranslation();
  const { p } = useProperty();
  const isAlternateSearchBarEnabled = p('Result.AlternateSearchBar.Enabled');
  const searchText = isOpen
    ? t('Result.ResultTripDetailsHeader.CloseSearch.Label')
    : t('Result.ResultTripDetailsHeader.EditSearch.Label');

  return (
    <>
      {!isAlternateSearchBarEnabled && (
        <button
          className={wrapperStyles(isAlternateSearchBarEnabled)}
          onClick={onClick}
          type="button"
        >
          <TripDetailsTitle />
          {!shouldShowSkeletonOnResultPage && (
            <span className={searchLabelStyles} data-testid="resultPage-searchHeaderButton-button">
              <span className={searchTextStyles}>{searchText}</span>
            </span>
          )}
        </button>
      )}
    </>
  );
};

export default ResultTripDetailsHeader;
